<template>
  <modal-window :main-width="9">
    <loading-spinner v-if="loading"></loading-spinner>
    <div v-if="!loading">
      <h2>Template Availability</h2>
      <p>Here you can set at which places in the application this template will be available.</p>
      <ul>
        <li>Board - Template is available next to "Create new Task" for manual creation</li>
        <li>Technical Occurrence / COMAT - Template is available for usage in Special Occurrence</li>
      </ul>

      <table class="table table-striped">
        <thead>
          <tr>
            <th>Available</th>
            <th>Type</th>
            <th>SortOrder</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="availability in availabilites" :key="availability.specialOccurrenceType">
            <td>
              <b-form-checkbox class="mb-1" v-model="availability.isAvailable" :value="true" :unchecked-value="false">
                Is available
              </b-form-checkbox>
            </td>
            <td>{{ availability.specialOccurrenceType.toLowerCase() == 'none' ? 'Board' : availability.specialOccurrenceType }}</td>

            <td>
              <input type="number" :disabled="!availability.isAvailable" class="form-control form-control-sm" v-model="availability.sortOrder" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <template #sidebar>
      <div class="d-flex flex-column justify-content-end h-100">
        <div class="label mb-2">
          <button class="btn btn-block btn-sm btn-info" @click="close">
            <i class="far fa-times"></i>
            Cancel
          </button>
        </div>
        <div class="label mb-2">
          <button class="btn btn-block btn-sm btn-success" @click="saveAndClose">
            <i class="far fa-save"></i>
            Save and close
          </button>
        </div>
      </div>
    </template>
  </modal-window>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { boardItemTemplateClient } from '@/apiclient/opsboard-api';
  import { BoardItemTemplateAvailabilityViewDto } from '@/apiclient/apiclient_generated';
  import LoadingSpinner from '@/components/Misc/LoadingSpinner.vue';
  import { Prop } from 'vue-property-decorator';
  import ModalWindow from '@/components/ModalWindow.vue';
  import { GlobalHelper } from "@/helpers/global-helper";

  @Component({ components: { ModalWindow, LoadingSpinner } })
  export default class BoardItemTemplateAvailabilityEdit extends Vue {
    @Prop() currentTemplateId: string;

    private availabilites: BoardItemTemplateAvailabilityViewDto[] = [];
    private loading = false;

    async mounted() {
      await this.loadData();
    }

    async loadData() {
      this.loading = true;
      this.availabilites = await boardItemTemplateClient.getAvailability(this.currentTemplateId);
      this.loading = false;
    }

    close() {
      this.$root.$bvModal.hide('editAvailabilityModal');
    }

    async saveAndClose() {
      await boardItemTemplateClient.storeAvailability(this.currentTemplateId, this.availabilites);
      GlobalHelper.NotifySuccess('Availability successfully stored');
      this.close();
    }
  }
</script>

<style scoped lang="scss"></style>
